import { StoreState } from '../store.model';

export const selectOpenings = (store: StoreState) => {
    const { selectedAppointment: appt } = store;
    return store?.filteredOpenings?.[appt?.id] ?? { openings: {}, closed: [] };
};
